module.exports = __webpack_public_path__ + "static/media/DSC_6729_HDR-Edit.4cd34d37.jpg";